import React, { useState } from 'react'
import styles from './FAQAccordion.module.css'

const faqs = [
  {
    question: 'What makes Recooty’s AI Interview Question Generator unique?',
    answer:
      'Our tool leverages advanced AI to produce role-specific, industry-aligned interview questions, saving you time and enhancing interview quality.Our Free AI Interview Question Generator caters to various roles across multiple industries, ensuring relevance and effectiveness.',
  },
  {
    question: 'Is the tool free?',
    answer:
      'Absolutely. Our AI Interview Question Generator is completely free to use.',
  },
  {
    question:
      'Is this AI Interview Question Generator tool useful for non-technical roles?',
    answer:
      'Absolutely. Whether you’re hiring for a Developer, Project manager, customer service rep, HR manager, marketer, or sales executive  -  our AI generates effective and targeted questions for all job functions.',
  },
  {
    question:
      'Can I export the questions into a document or share with my team?',
    answer:
      ' Yes, once the questions are generated, you can copy them and paste into a document or email, or share them directly with your hiring team.',
  },
  {
    question:
      'Do I need to pay or sign up to use the AI tool for interview questions?',
    answer:
      'No login or credit card is required. The AI Interview Question Generator is 100% free to use with no hidden costs..',
  },
  {
    question:
      'Is this tool better than downloading templates or using ChatGPT?',
    answer:
      'Unlike generic templates or general-purpose AI models, our generator is purpose-built and trained on recruitment-focused data  -  offering more accurate, industry-aligned questions',
  },
]

const FAQAccordion = () => {
  const [openIndex, setOpenIndex] = useState(0)

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <div className={styles.container}>
      {/* Left Column */}
      <div className={styles.leftColumn}>
        <h2 className={styles.heading}>
          Got Questions? Have<br /> a  Look Here!
        </h2>
        <p className={styles.subtext}>
          Couldn’t find what you were looking for?
        </p>
        <p className={styles.subtext}>Write to us at.</p>
        <a href="mailto:support@recooty.com" className={styles.emailLink}>
          support@recooty.com
        </a>
      </div>

      {/* Right Column - FAQ Accordion */}
      <div className={styles.rightColumn}>
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`${styles.faqCard} ${
              openIndex === index ? styles.activeCard : ''
            }`}
          >
            <button onClick={() => toggle(index)} className={styles.faqButton}>
              <h3 className={styles.faqQuestion}>{faq.question}</h3>
              <span
                className={styles.icon}
                style={{
                  transition: 'transform 0.2s',
                  transform:
                    openIndex === index ? 'rotate(45deg)' : 'rotate(0deg)',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {/* Plus Icon SVG (rotated to X when open) */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  className={styles.iconSvg}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 4v16m8-8H4"
                  />
                </svg>
              </span>
            </button>

            <div
              className={`${styles.faqAnswer} ${
                openIndex === index ? styles.answerOpen : ''
              }`}
            >
              {faq.answer}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FAQAccordion
